import React from 'react'

import { useHistory } from 'react-router-dom'

import PageIntroContractors from '../../../../../presentation/pages/contractors/amplify/introContractors/introContractors'

function MakeIntroContractors(): JSX.Element {
  const history = useHistory()

  const handleBackClick = (evt: React.MouseEvent<HTMLButtonElement>): void => {
    evt.preventDefault()
    history.goBack()
  }

  const props = {
    handleBackClick,
  }

  return <PageIntroContractors {...props} />
}

export default MakeIntroContractors
